// src/components/ThemeToggle/ThemeToggle.jsx
import React, { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";
import "./nav.css"; // your existing CSS

const ThemeToggle = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "dark"
  );

  // whenever theme changes, write it out
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  // listen for other tabs/components writing to localStorage
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "theme" && e.newValue) {
        setTheme(e.newValue);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggle = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className="theme-toggle">
      {theme === "light" ? <Sun size={20} className="icon" /> : <Moon size={20} className="icon" />}
      <input
        type="checkbox"
        id="theme-toggle-checkbox"
        checked={theme === "light"}
        onChange={toggle}
      />
      <label htmlFor="theme-toggle-checkbox" className="switch" />
    </div>
  );
};

export default ThemeToggle;
